"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Text = _interopRequireDefault(require("../../style/annotations/Text.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var REPLACE_PADDING = 5;
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;
var CARET_HEIGHT = 15;
var CARET_WIDTH = 22;

var Replace = function Replace(_ref) {
  var annotation = _ref.annotation,
      commentProposedForDelete = _ref.commentProposedForDelete,
      disableInteraction = _ref.disableInteraction,
      hoveredAnnotation = _ref.hoveredAnnotation,
      isPlacingAnnotation = _ref.isPlacingAnnotation,
      annotationId = _ref.annotationId,
      onReplaceDown = _ref.onReplaceDown,
      onReplaceHover = _ref.onReplaceHover,
      scaleFactorX = _ref.scaleFactorX,
      scaleFactorY = _ref.scaleFactorY;
  var selector = annotation.target.selector;
  var pathColor = selector.strokeColor;
  var pathOpacity = selector.opacity || 0.4;
  var pathWidth = selector.strokeWidth || 2;
  var boundingBox = selector.boundingBox;
  var left = boundingBox[0] * scaleFactorX - REPLACE_PADDING;
  var top = boundingBox[3] * scaleFactorY - REPLACE_PADDING;
  var width = (boundingBox[2] - boundingBox[0]) * scaleFactorX + REPLACE_PADDING * 2;
  var height = (boundingBox[1] - boundingBox[3]) * scaleFactorY + REPLACE_PADDING * 2;
  var rects = [];
  var lastLeft;
  var lastTop;
  var lastWidth;
  var lastHeight;

  if (!selector.inkList) {
    return null;
  }

  var isVertical;
  selector.inkList.forEach(function (line, lineIdx) {
    var lineLeft = Math.min.apply(Math, _toConsumableArray(line.map(function (point) {
      return point.x;
    }))) * scaleFactorX;
    var lineTop = Math.min.apply(Math, _toConsumableArray(line.map(function (point) {
      return point.y;
    }))) * scaleFactorY;
    var lineRight = Math.max.apply(Math, _toConsumableArray(line.map(function (point) {
      return point.x;
    }))) * scaleFactorX;
    var lineBottom = Math.max.apply(Math, _toConsumableArray(line.map(function (point) {
      return point.y;
    }))) * scaleFactorY;
    var lineWidth = lineRight - lineLeft;
    var lineHeight = lineBottom - lineTop;
    isVertical = lineHeight > lineWidth;
    lastLeft = lineLeft - left;
    lastTop = lineTop - top;
    lastWidth = lineWidth;
    lastHeight = lineHeight;
    rects.push( /*#__PURE__*/_react.default.createElement("svg", {
      key: "id-".concat(lineIdx),
      width: lineWidth,
      height: lineHeight,
      style: {
        left: lastLeft,
        top: lastTop
      }
    }, /*#__PURE__*/_react.default.createElement("line", {
      x1: isVertical ? '50%' : '0%',
      y1: isVertical ? '0%' : '50%',
      x2: isVertical ? '50%' : '100%',
      y2: isVertical ? '100%' : '50%',
      style: {
        stroke: pathColor,
        fillOpacity: pathOpacity,
        strokeWidth: pathWidth
      }
    })));
  });
  var caretLeft = lastLeft + lastWidth - CARET_WIDTH / 2 * scaleFactorX;
  var caretTop = lastTop + lastHeight / 2;

  if (isVertical) {
    caretLeft = lastWidth / 2 - lastLeft;
    caretTop = lastTop + lastHeight;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-html2canvas-ignore": annotationId === 'annotation-placeholder' ? null : true,
    className: (0, _classnames.default)(_Text.default.component, {
      'temp-replace': annotationId === 'annotation-placeholder',
      'hovered-text-annotation': hoveredAnnotation === annotationId || commentProposedForDelete && annotationId === commentProposedForDelete.id,
      'ignore-mouse-events': isPlacingAnnotation || disableInteraction
    }),
    "data-annotationid": annotationId,
    "data-annotationtype": "replace",
    style: {
      left: "".concat(left, "px"),
      top: "".concat(top, "px"),
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    },
    onPointerDown: POINTER_EVENTS_SUPPORTED ? onReplaceDown : undefined,
    onMouseDown: POINTER_EVENTS_SUPPORTED ? undefined : onReplaceDown,
    onTouchStart: POINTER_EVENTS_SUPPORTED ? undefined : onReplaceDown,
    onMouseEnter: onReplaceHover,
    onMouseLeave: onReplaceHover
  }, rects, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: CARET_WIDTH,
    height: CARET_HEIGHT,
    viewBox: "0 0 34 24",
    style: {
      fill: pathColor,
      left: caretLeft,
      top: caretTop
    }
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,24 L34,24 C22.6051595,22.7481684 16.9384929,14.4434308 17,-0.91421274 C16.9384929,14.4316616 11.2718262,22.7363991 0,24 Z"
  })));
};

Replace.displayName = 'Replace';
Replace.defaultProps = {
  isPlacingAnnotation: false,
  onReplaceDown: function onReplaceDown() {},
  onReplaceHover: function onReplaceHover() {},
  scaleFactorX: 1,
  scaleFactorY: 1
};
Replace.propTypes = {
  annotation: _propTypes.default.object,
  commentProposedForDelete: _propTypes.default.object,
  disableInteraction: _propTypes.default.bool,
  hoveredAnnotation: _propTypes.default.string,
  isPlacingAnnotation: _propTypes.default.bool,
  onReplaceDown: _propTypes.default.func,
  onReplaceHover: _propTypes.default.func,
  annotationId: _propTypes.default.string,
  scaleFactorX: _propTypes.default.number,
  scaleFactorY: _propTypes.default.number
};
var _default = Replace;
exports.default = _default;